/**
 * Constantes utilisées pour les ressources des enfants
 */
export class ConstantesRessourcesEnfant {

    /**
     * code associé à la ressource salaire
     */
    public static CODE_SALAIRE = "salaire";

    /**
     * code associé à la ressource allocation de chomage
     */
    public static CODE_ALLOCATION_CHOMAGE = "allocation_chomage";

    /**
     *  code associé à la ressource revenu travailleur indépendant
     */
    public static CODE_REVENU_TRAVAILLEUR_INDEPENDANT = "revenu_travailleur_independant";

    /**
     * Pattern pour la validation des montant (entiers > 0)
     */
    public static  PATTERN_NUMERIQUE_ENTIER_POSITIF = "^([1-9][0-9]*)$";

    /**
     * Pattern pour la validation des montant (entiers)
     */
    public static PATTERN_NUMERIQUE_ENTIER = "^[-]?([1-9][0-9]*)$";

    /**
     * Map qui définit les libellés et les erreurs possibles sur les montants des ressources enfant
     */
    public static MAP_ERREURS_MONTANTS = new Map<string, string>([
        ["required", "Champ obligatoire"],
        ["pattern", "Ce montant doit être un nombre entier"]
    ]);
}
